import api from '../api/axios'

const BASE = (orgId) => `/organizadores/${orgId}/filtros-baterias`
const JUST = (orgId) => `/organizadores/${orgId}/ordem-entrada`

const filtrosBateriasService = {
  listar: (orgId) => api.get(BASE(orgId)).then(r => r.data),

  criar: (orgId, payload) => api.post(BASE(orgId), payload).then(r => r.data),

  obter: (orgId, filtroId) => api.get(`${BASE(orgId)}/${filtroId}`).then(r => r.data),

  atualizar: (orgId, filtroId, payload) =>
    api.put(`${BASE(orgId)}/${filtroId}`, payload).then(r => r.data),

  excluir: (orgId, filtroId) =>
    api.delete(`${BASE(orgId)}/${filtroId}`).then(r => r.data),

  validar: (orgId, filtroId, leilaoId) =>
    api.get(`${BASE(orgId)}/${filtroId}/validar?leilao_id=${leilaoId}`).then(r => r.data),

  aplicar: (orgId, filtroId, leilaoId, modo = 'redefinir') =>
    api.post(`${BASE(orgId)}/${filtroId}/aplicar/${leilaoId}?modo=${modo}`).then(r => r.data),

  salvarHorarioLimite: (orgId, leilaoId, payload) =>
    api.put(`${JUST(orgId)}/${leilaoId}/horario-limite`, payload).then(r => r.data),

  salvarEncaixeAutomatico: (orgId, leilaoId, ativo) =>
    api.put(`${JUST(orgId)}/${leilaoId}/encaixe-automatico`, { ativo }).then(r => r.data),

  // Justificativas
  registrarJustificativa: (orgId, leilaoId, payload) =>
    api.post(`${JUST(orgId)}/${leilaoId}/justificativas`, payload).then(r => r.data),

  listarJustificativasLeilao: (orgId, leilaoId, params = {}) =>
    api.get(`${JUST(orgId)}/${leilaoId}/justificativas`, { params }).then(r => r.data),

  listarJustificativasOrg: (orgId, params = {}) =>
    api.get(`${JUST(orgId)}/justificativas`, { params }).then(r => r.data),
}

export default filtrosBateriasService
